import { render, staticRenderFns } from "./DISCard.vue?vue&type=template&id=6d5a3f14&scoped=true&"
import script from "./DISCard.vue?vue&type=script&lang=js&"
export * from "./DISCard.vue?vue&type=script&lang=js&"
import style0 from "./DISCard.vue?vue&type=style&index=0&id=6d5a3f14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a3f14",
  null
  
)

export default component.exports